import React, { useState, useEffect } from "react";
import {
  Tab,
  Button,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { BasicDrawer } from "../../../components/Shared";
import {
  ListEffluentForms,
  EffluentForm,
} from "../../../components/Admin/EffluentForms";
import { useAuth } from "../../../hooks";
import { Form, Effluentform } from "../../../api";
import { encrypt, decrypt } from "../../../utils/cryptoUtils";
import { useLocation, useNavigate } from "react-router-dom";

// `text` sale de las traducciones (t(key)) al renderizar, no acá — estos
// keys ("water", "effluent", etc.) ya existen en los .json de i18n.
const QUESTIONNAIRE_OPTIONS = [
  { key: "water",       value: "/admin/data/waterforms" },
  { key: "effluent",    value: "/admin/data/effluentforms" },
  // { key: "air",          value: "/admin/data/airemissionsforms" },
  { key: "energy",      value: "/admin/data/energyforms" },
  // { key: "envobjetives", value: "/admin/data/environmentalobjetives" },
  { key: "production",  value: "/admin/data/productionforms" },
  { key: "waste",       value: "/admin/data/wasteforms" },
  { key: "social",      value: "/admin/data/socialforms" },
  { key: "fuel",        value: "/admin/data/fuelsforms" },
];
import {
  // hasPermission,
  isAdmin,
  isMaster,
  isEditor,
} from "../../../utils/checkPermission";
import "./EffluentForms.scss";
import { useLanguage, useSite } from "../../../contexts";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { effluentCodes } from "../../../utils/dataAndFormulas/effluentForms";

const formController = new Form();
const effluentFormController = new Effluentform();

export function EffluentForms() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const {
    accessToken,
    user: { role, site },
  } = useAuth();
  const [siteSelected, setSiteSelected] = useState(null);
  const [yearSelected, setYearSelected] = useState(new Date().getFullYear());
  const [configFormData, setConfigFormData] = useState([]);
  const [unitsRecorded, setUnitsRecorded] = useState({});

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  const [loading, setLoading] = useState(true);

  const { translations, language } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  // Función para verificar si hay al menos una unidad configurada
  const validateUnitsConfigured = () => {
    // Si no hay configFormData o no hay fields, permitir continuar (usará campos por defecto)
    if (!configFormData?.fields || configFormData.fields.length === 0) {
      return { valid: true };
    }

    // Filtrar solo los campos activos
    const activeFields = configFormData.fields.filter(field => field.active !== false);

    if (activeFields.length === 0) {
      return { valid: false, message: t("no_active_fields") };
    }

    // Verificar que haya al menos UNA unidad configurada
    const fieldsWithUnit = activeFields.filter(field => field.unit && field.unit !== "");

    if (fieldsWithUnit.length === 0) {
      return {
        valid: false,
        message: t("units_not_configured") || "Debe configurar al menos una unidad antes de agregar un periodo. Haga clic en el ícono de tres puntos (⋯) en la columna de Unidades."
      };
    }

    return { valid: true };
  };

  // Función para manejar la apertura del modal de nuevo formulario
  const handleOpenNewForm = () => {
    const validation = validateUnitsConfigured();
    if (!validation.valid) {
      toast.error(validation.message);
      return;
    }
    onOpenCloseModal();
  };

  const location = useLocation();

  const siteContext = useSite().site;

  useEffect(() => {
    (async () => {
      try {
        if (siteContext !== "") {
          setSiteSelected(siteContext);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [siteContext]);

  useEffect(() => {
    (async () => {
      try {
        if (site) {
          setSiteSelected(site);
        }
      } catch (error) {
        console.error(error);
        setSiteSelected(null);
      }
    })();
  }, [site]);

  useEffect(() => {
    (async () => {
      try {
        if (location.state?.siteSelected) {
          setSiteSelected(decrypt(location.state.siteSelected));
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [location]);

  
      useEffect(() => {
        (async () => {
          try {
              setLoading(true);
              if (siteSelected && siteSelected !== "" && siteSelected !=="undefined") {
                const response = await formController.getFormsBySite(
                  accessToken,
                  siteSelected,
                  "effluent"
                );
                if (response.length > 0) {
                  setConfigFormData(response[0]);
                }
                setLoading(false);
            }
          } catch (error) {
            console.error(error);
            setConfigFormData([]);
          }
        })();
      }, [siteSelected, accessToken, reload]);

  // Cargar unidades cuando cambia configFormData o siteSelected
  useEffect(() => {
    (async () => {
      try {
        if (siteSelected && yearSelected) {
          // Determinar campos activos
          const fields = new Set();
          if (configFormData?.fields && configFormData.fields.length > 0) {
            Object.keys(effluentCodes).forEach((key) => {
              if (configFormData.fields.some((field) => field.name === key && field.active)) {
                fields.add(key);
              }
            });
          } else {
            Object.keys(effluentCodes).forEach((key) => {
              fields.add(key);
            });
          }
          const uniqueFields = Array.from(fields);

          if (uniqueFields.length > 0) {
            let recordedUnits = {};

            // 1. Primero intentar obtener las unidades desde configFormData.fields
            if (configFormData?.fields && configFormData.fields.length > 0) {
              configFormData.fields.forEach((field) => {
                if (field.unit && field.name) {
                  recordedUnits[field.name] = field.unit;
                }
              });
            }

            // 2. Si no hay unidades en configFormData, obtener de los formularios guardados
            if (Object.keys(recordedUnits).length === 0) {
              const response = await effluentFormController.getLastUnitFieldsByYear(
                accessToken,
                siteSelected,
                yearSelected,
                uniqueFields
              );

              if (response.code === 200) {
                recordedUnits = response.fields;
              }
            }

            setUnitsRecorded(recordedUnits);
          }
        }
      } catch (error) {
        console.error(error);
        setUnitsRecorded({});
      }
    })();
  }, [configFormData, siteSelected, yearSelected, accessToken, reload]);

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          {siteSelected === null &&
          (isMaster(role) || (isAdmin(role) && !site)) ? (
            <div className="no-site-warning">
              <Icon name="warning sign" size="big" />
              <p>{t("select_company_site_from_header")}</p>
            </div>
          ) : (
            <ListEffluentForms
              reload={reload}
              onReload={onReload}
              siteSelected={siteSelected}
              yearSelected={yearSelected}
              configFormData={configFormData}
            />
          )}
        </Tab.Pane>
      ),
    },
  ];

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  return (
    <>
      <div className="effluent-forms-page">
        <div className="effluent-page-header-wrapper">
          <div className="effluent-page-header">
            <Dropdown
              className="effluent-questionnaire-dropdown"
              options={QUESTIONNAIRE_OPTIONS
                .map((opt) => ({ ...opt, text: t(opt.key) }))
                .sort((a, b) => a.text.localeCompare(b.text, language))}
              selection
              onChange={(_, data) => navigate(data.value)}
              value="/admin/data/effluentforms"
            />
            <div className="effluent-page-actions">
              {(siteSelected !== null || site) ? (
                <Dropdown
                  className="effluent-year-dropdown"
                  placeholder={t("select")}
                  options={years.map((year) => ({ key: year, text: year, value: year }))}
                  selection
                  onChange={(_, data) => setYearSelected(data.value)}
                  value={yearSelected}
                />
              ) : null}
            </div>
          </div>
          {(siteSelected !== null || site) && (isAdmin(role) || isEditor(role) || isMaster(role)) ? (
            <Button icon className="effluent-add-btn" onClick={handleOpenNewForm}>
              <Icon name="plus" />
            </Button>
          ) : null}
        </div>

        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      <BasicDrawer
        show={showModal}
        close={onOpenCloseModal}
      >
        <EffluentForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          year={yearSelected}
          siteSelected={siteSelected}
          configFormData={configFormData}
          unitsRecorded={unitsRecorded}
        />
      </BasicDrawer>
    </>
  );
}

